<script lang="ts">
  import MetaData from "$lib/MetaData.svelte";
  import type { PblContract } from "$lib/types/contracts";
  import { contentBlockComponents } from "$lib/portableText/utils";
  import { PortableText } from "@portabletext/svelte";
  import Picture from "$lib/Picture.svelte";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";

  interface Props {
    data: {
      plusskunde_contract: Readonly<PblContract>;
    };
  }

  let { data }: Props = $props();
  let contract = $derived(data?.plusskunde_contract?.contract);
</script>

<MetaData data={{ title: contract.name, description: contract.description }} />

<h1 class="px-edge-x">{contract.name}</h1>
{#if contract?.image?.src}
  <div class="mx-edge-x max-w-prose">
    <Picture
      src={contract.image.src}
      alt={contract.image.alt}
      srcset={contract.image.srcset}
      srcsetWebp={contract.image.srcsetWebp}
      sizes={`(min-width: ${br.desktop}) 30vw, (min-width: ${br.laptop}) 30vw, 100vw`}
      width={contract.image?.asset?.metadata?.dimensions?.width}
      height={contract.image?.asset?.metadata?.dimensions?.height}
      class="w-full object-cover laptop:rounded-2xl"
    />
  </div>
{/if}
<div class="px-edge-x">
  <p class="text-lead max-w-prose mb-4">{contract.description}</p>
  <div class="flex gap-8 responsive-wrapper text-body">
    <div class="max-w-prose">
      <PortableText
        value={contract.content}
        components={contentBlockComponents}
        onMissingComponent={false}
      />
      {#if contract.documents && contract.documents.length > 0}
        <ul class="my-8">
          {#each contract.documents as doc (doc)}
            <li>
              <a href={doc.url} target="_blank">{doc.title ?? "Fil uten navn"}</a>
            </li>
          {/each}
        </ul>
      {/if}
      {#if contract.finePrint}
        <div class="max-w-prose my-3 children-my-1 text-base">
          <PortableText
            value={contract.finePrint}
            components={contentBlockComponents}
            onMissingComponent={false}
          />
        </div>
      {/if}
    </div>
  </div>
</div>

<style>
  .responsive-wrapper {
    flex-direction: column;
  }
  @media (--laptop) {
    .responsive-wrapper {
      flex-direction: row;
    }
  }
</style>
